import { render, staticRenderFns } from "./nv-loading.vue?vue&type=template&id=5262c5b6&scoped=true&"
import script from "./nv-loading.vue?vue&type=script&lang=ts&"
export * from "./nv-loading.vue?vue&type=script&lang=ts&"
import style0 from "./nv-loading.vue?vue&type=style&index=0&id=5262c5b6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5262c5b6",
  null
  
)

export default component.exports